/**
 * StudentApp.tsx
 * Root of the student-facing mobile web portal.
 * Accessible at /join — no Office.js required.
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import JoinRoom from './JoinRoom';
import StudentPlay from './StudentPlay';
import StudentLeaderboard from './StudentLeaderboard';

export default function StudentApp(): React.ReactElement {
  return (
    <div className="min-h-screen bg-surface font-sans">
      <Routes>
        <Route path="/" element={<JoinRoom />} />
        {/* Single play view that follows whatever activity is live */}
        <Route path="/play" element={<StudentPlay />} />
        <Route path="/leaderboard" element={<StudentLeaderboard />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
